import { render, staticRenderFns } from "./checkout-policy.vue?vue&type=template&id=20b664dc&scoped=true"
import script from "./checkout-policy.vue?vue&type=script&lang=js"
export * from "./checkout-policy.vue?vue&type=script&lang=js"
import style0 from "./checkout-policy.vue?vue&type=style&index=0&id=20b664dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b664dc",
  null
  
)

export default component.exports